import { render, staticRenderFns } from "./ProductDrawer.vue?vue&type=template&id=4fbcdb97&scoped=true&"
import script from "./ProductDrawer.vue?vue&type=script&lang=js&"
export * from "./ProductDrawer.vue?vue&type=script&lang=js&"
import style0 from "./ProductDrawer.vue?vue&type=style&index=0&id=4fbcdb97&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbcdb97",
  null
  
)

export default component.exports